import type {LinkBasicDto, ObjectScopedLinkDto} from "../../generated/api/base";
import {XyiconFeature} from "../../generated/api/base";
import type {IModel} from "./Model";

type LinkDto = LinkBasicDto | ObjectScopedLinkDto;

export class Link implements IModel {
	private _data: LinkDto;
	private _isSelected: boolean = false;
	public readonly ownFeature: XyiconFeature = XyiconFeature.Link;

	constructor(data: LinkDto) {
		this.applyData(data);
	}

	public applyData(data: Partial<LinkDto>) {
		this._data = {
			...this._data,
			...data,
		};
	}

	public get id() {
		return this._data.linkID;
	}

	public get objectAPortfolioID() {
		return this._data.objectAPortfolioID;
	}

	public get objectBPortfolioID() {
		return this._data.objectBPortfolioID;
	}

	public get objectAID() {
		return this._data.objectAID;
	}

	public get objectBID() {
		return this._data.objectBID;
	}

	public get objectABoundaryID() {
		return (this._data as ObjectScopedLinkDto).objectABoundaryID;
	}

	public get objectBBoundaryID() {
		return (this._data as ObjectScopedLinkDto).objectBBoundaryID;
	}

	public get objectAPortID() {
		return this._data.objectAPortID;
	}

	public get objectBPortID() {
		return this._data.objectBPortID;
	}

	public get isEmbedded() {
		return this._data.isEmbedded;
	}

	public get objectALinkType() {
		return this._data.objectALinkType;
	}

	public get objectBLinkType() {
		return this._data.objectBLinkType;
	}

	public get linkProperties() {
		return this._data.linkProperties;
	}

	public get lastModifiedBy() {
		return this._data.lastModifiedBy;
	}

	public get lastModifiedAt() {
		return this._data.lastModifiedAt;
	}

	public get data() {
		return this._data;
	}

	public get isSelected() {
		return this._isSelected;
	}

	public set isSelected(isSelected: boolean) {
		this._isSelected = isSelected;
	}
}
